






















































































import Vue from 'vue'
import { Component, Emit, Prop, Watch } from 'vue-property-decorator'

import CreateNewProperty from '../../../../../../../../../BotProperties/components/Properties/CreateNewProperty.vue'
import { getNewPropertyIcon, getPropertyTranslation } from '../../../../../../../../../BotProperties/utils'
import MultiMessageEditorWithMediaInput from '../../../../../../../../../Pi/fields/NewMultiMessageEditorWithMediaInput/MultiMessageEditorWithMediaInput.vue'
import SelectInput from '../../../../../../../../../Pi/fields/SelectInput/SelectInput.vue'
import { FieldData, SelectOptionData } from '../../../../../../../../../Pi/types'
import { SocketsActionsTypes } from '../../../../../../../components'
import CustomEditor from '../../../../../../Editor/CustomEditor'
import ProxyTypingAction from '../../../logic/Proxy/actions/ProxyTypingAction'
import ProxyUserInputAction from '../../../logic/Proxy/actions/ProxyUserInputAction'
import { SendMessageNode } from '../../../logic/SendMessageNode'
import { SendMessageNodeProps } from '../../../logic/types'
import UserInputActionAdditionalSettings from './UserInputActionComponents/UserInputActionAdditionalSettings.vue'

@Component({
  components: {
    MultiMessageEditorWithMediaInput,
    SelectInput,
    UserInputActionAdditionalSettings,
    CreateNewProperty,
  }
})
export default class UserInputAction extends Vue {
  @Prop() action!: ProxyUserInputAction

  @Prop() typingAction!: ProxyTypingAction | null

  @Prop() nodeProps!: SendMessageNodeProps

  @Prop() nodeSocketsActions!: SocketsActionsTypes

  @Prop() editor!: CustomEditor

  @Prop() node!:SendMessageNode

  newProperty = ''

  createNewPropertyIsOpen = false

  selectTemplate = 0

  @Watch('createNewPropertyIsOpen')
  isOpenWatcher(val: boolean): void {
    if (!val) {
      this.selectTemplate += 1
    }
  }

  get placeholders() {
    if (typeof this.nodeProps.placeholders === 'function') {
      return this.nodeProps.placeholders()
    } else {
      return []
    }
  }

  get properties(): Array<SelectOptionData> {
    return this.action.nodeProps.getProperties()
      .filter(p => !p?.readOnly && !p?.automatic)
      .map((p) => {
        return {
          label: getPropertyTranslation(this.$i18n, p.name ?? p.type),
          value: p.id,
          icon: {
            iconPack: 'material-icons',
            name: getNewPropertyIcon(p.path ?? p.type)
          }
        }
      })
  }

  selectProperty(arg: FieldData): FieldData {
    arg.setter = (val) => this.action.setPropertyIndex(val)
    return arg
  }

  setFailVariants(arg: FieldData): FieldData {
    arg.setter = (val) => this.action.setFailVariants(val)
    return arg
  }
  @Emit()
  switchTyping(): this {
    return this
  }

  prepareNewProperty({ label }: { label: string }): void {
    this.newProperty = label
    this.createNewPropertyIsOpen = true
  }

  createNewProperty(path: string, name: string) {
    return this.nodeProps.createNewProperty(path, name)
  }
}
